import { render, staticRenderFns } from "./EditPrintedCopy.vue?vue&type=template&id=1384f4b4&scoped=true&"
import script from "./EditPrintedCopy.vue?vue&type=script&lang=js&"
export * from "./EditPrintedCopy.vue?vue&type=script&lang=js&"
import style0 from "./EditPrintedCopy.vue?vue&type=style&index=0&id=1384f4b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1384f4b4",
  null
  
)

export default component.exports